import React, { useEffect, useState } from "react";
import "./styles/adminpage.css";

export default function AdminPage() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("username");
  const [editUser, setEditUser] = useState(null);

  // fetch users
  const loadUsers = async () => {
    const res = await fetch("https://hcfullstack.onrender.com/admin/users");
    const data = await res.json();
    setUsers(data.users || []);
  };

  useEffect(() => {
    loadUsers();
  }, []);

  // delete
 const deleteUser = async (id) => {
  if (!window.confirm("Delete this user?")) return;

  const res = await fetch(
    `https://hcfullstack.onrender.com/admin/users/${id}`,
    {
      method: "DELETE",
    }
  );

  if (!res.ok) {
    alert("Delete failed");
    return;
  }

  loadUsers();
};

  // update
  const updateUser = async () => {
    await fetch(`https://hcfullstack.onrender.com/admin/users/${editUser.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editUser),
    });
    setEditUser(null);
    loadUsers();
  };

  const filteredUsers = users.filter((u) =>
    u[filter]?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin">
      {/* TOP BAR */}
      <div className="adminTop">
        <h2>Admin Panel</h2>

        <div className="searchBox">
          <i className="fa fa-search" />
          <input
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select onChange={(e) => setFilter(e.target.value)}>
            <option value="username">Username</option>
            <option value="phone">Phone</option>
            <option value="job">Job</option>
            <option value="location">Location</option>
          </select>
        </div>

        <button
          className="logout"
          onClick={() => {
            localStorage.clear();
            window.location.href = "/useradmin";
          }}
        >
          Logout
        </button>
      </div>

      {/* TABLE */}
      <table>
        <thead>
          <tr>
            <th>Username</th>
            <th>Phone</th>
            <th>Job</th>
            <th>Location</th>
            <th>Degree</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {filteredUsers.map((u) => (
            <tr key={u.id}>
              <td>{u.username}</td>
              <td>{u.phone}</td>
              <td>{u.job}</td>
              <td>{u.location}</td>
              <td>{u.degree}</td>
              <td>
                <button onClick={() => setEditUser(u)}>✏️</button>
                <button onClick={() => deleteUser(u.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* EDIT MODAL */}
      {editUser && (
        <div className="modal">
          <div className="modalBox">
            <h3>Edit User</h3>

            <input
              value={editUser.username}
              onChange={(e) =>
                setEditUser({ ...editUser, username: e.target.value })
              }
            />
            <input
              value={editUser.phone}
              onChange={(e) =>
                setEditUser({ ...editUser, phone: e.target.value })
              }
            />
            <input
              value={editUser.job}
              onChange={(e) =>
                setEditUser({ ...editUser, job: e.target.value })
              }
            />
            <input
              value={editUser.location}
              onChange={(e) =>
                setEditUser({ ...editUser, location: e.target.value })
              }
            />
            <input
              value={editUser.degree}
              onChange={(e) =>
                setEditUser({ ...editUser, degree: e.target.value })
              }
            />

            <div className="modalActions">
              <button onClick={updateUser}>Save</button>
              <button onClick={() => setEditUser(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
